/**
 * Utility functions for handling files and images with URL structure
 */

/**
 * Download a blob to the browser
 * @param blob - The blob to download
 * @param filename - The filename for the download
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = window.document.createElement('a');
  link.href = url;
  link.download = filename || 'document';
  link.style.display = 'none';
  window.document.body.appendChild(link);
  link.click();
  window.document.body.removeChild(link);
  // Keep the blob URL alive briefly — Safari often fails if revoked immediately.
  window.setTimeout(() => window.URL.revokeObjectURL(url), 2000);
};
